{
	"selectAll": "Tout sélectionner"
}
